import React from 'react';
import PropTypes from 'prop-types';
import { getButtonTarget } from '../../utils/buttons';

import { ButtonShape, ButtonPropertyDefaults } from '../../global-constants';

export default class ImageButton extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			imageSrc: props.buttonProps.image,
			customStyles: {}
		};
	}

	componentDidMount() {
		const {
			buttonProps: { image }
		} = this.props;
		this.setImageSrc(image);
	}

	setImageSrc(src) {
		if (src && src.length > 0) {
			this.setState({
				imageSrc: src
			});
		}
	}

	render() {
		const { buttonProps, handleCtaClicked } = this.props;

		const {
			btnLabel,
			btnClasses,
			btnHref,
			btnTarget,
			hoverImage,
			image,
			btnAttributes
		} = buttonProps;

		const { imageSrc, customStyles } = this.state;

		const displayProps = {
			title: btnLabel,
			alt: btnLabel
		};
		if (hoverImage) {
			displayProps.onMouseEnter = _e => {
				this.setImageSrc(hoverImage);
			};
			displayProps.onMouseLeave = _e => {
				this.setImageSrc(image);
			};
		}
		return (
			<a
				className={btnClasses}
				href={btnHref}
				target={getButtonTarget(btnTarget)}
				style={customStyles}
				{...btnAttributes}
				onClick={() => {
					handleCtaClicked(btnLabel);
				}}
			>
				<img alt={btnLabel} src={imageSrc} {...displayProps} />
			</a>
		);
	}
}

ImageButton.propTypes = {
	buttonProps: ButtonShape,
	handleCtaClicked: PropTypes.func
};

ImageButton.defaultProps = {
	buttonProps: ButtonPropertyDefaults,
	handleCtaClicked: () => {}
};



// WEBPACK FOOTER //
// ./src/components/Buttons/ImageButton.jsx